module.exports = __webpack_public_path__ + "static/img/star2.56b30de1.png";